import { GetIndicatorsQuery } from '../../../redux/slices/indicatorDisplay/indicator/indicatorThunk';
import { DraftSources, FilterDraft, FilterIds } from './filterDraft';
import { getIdsByTitle, resolveFilterTree, rightTitlesToIds } from './filterTree';
import { findSelected } from './helpers';

export const getParamsToClean =(value: 'typeIndicator' | 'dimension' | 'subdimension' | 'indicators' | 'ods-priority_groups' | 'search' | 'all-filters'): Record<string, null> => {
    switch (value) {
        case 'typeIndicator':
            return { type: null, dimensionID: null, subdimensionID: null, indicator: null, indicatorID: null, ods: null, odsID: null, priorityGroups: null, priorityGroupsID: null, page: null };
        case 'dimension':
            return { dimensionID: null, subdimensionID: null, indicator: null, indicatorID: null };
        case 'subdimension':
            return { subdimensionID: null, indicator: null, indicatorID: null };
        case 'indicators':
            return { indicator: null, indicatorID: null };
        case 'ods-priority_groups':
            return { type: null, dimensionID: null, subdimensionID: null, indicator: null, indicatorID: null, page: null };
        case 'all-filters':
            return { right: null, type: null, dimensionID: null, subdimensionID: null, indicator: null, indicatorID: null, ods: null, odsID: null, priorityGroups: null, priorityGroupsID: null, rightId: null, filterApplied: null }
        case 'search':
            return { searchMode: null, search: null, indicatorID: null }
    }
};

// URL -> ids de cada filtro
export const idsFromUrl = (getMultipleParams: (key: string) => string[]): FilterIds => ({
    rightId: getMultipleParams("rightId"),
    type: getMultipleParams("type"),
    dimensionID: getMultipleParams("dimensionID"),
    subdimensionID: getMultipleParams("subdimensionID"),
    indicatorID: getMultipleParams("indicatorID"),
    odsID: getMultipleParams("odsID"),
    priorityGroups: getMultipleParams("priorityGroups"),
});

// borrador -> ids (las dimensiones/subdimensiones/indicadores repetidos mandan todos sus ids)
export const idsFromDraft = (draft: FilterDraft, { rights, odsOptions, priorityGroupsOptions }: DraftSources): FilterIds => {
    const draftRights = rights.filter(r => draft.rights.includes(r.titulo));
    const { all } = resolveFilterTree(draftRights, draft);

    return {
        rightId: rightTitlesToIds(rights, draft.rights),
        type: draft.types,
        dimensionID: getIdsByTitle(all.dimensions, draft.dimensions),
        subdimensionID: getIdsByTitle(all.subdimensions, draft.subdimensions),
        indicatorID: getIdsByTitle(all.indicators, draft.indicators),
        odsID: findSelected(draft.ods, odsOptions).ids,
        priorityGroups: findSelected(draft.priorityGroups, priorityGroupsOptions).ids,
    };
};

// ids -> params de la URL (las listas vacías se borran)
export const idsToParams = (ids: FilterIds): Record<keyof FilterIds, string[] | null> => {
    const toParam = (values: string[]) => values.length ? values : null;

    return {
        rightId: toParam(ids.rightId),
        type: toParam(ids.type),
        dimensionID: toParam(ids.dimensionID),
        subdimensionID: toParam(ids.subdimensionID),
        indicatorID: toParam(ids.indicatorID),
        odsID: toParam(ids.odsID),
        priorityGroups: toParam(ids.priorityGroups),
    };
};

// ids -> consulta al back
export const idsToQuery = (ids: FilterIds): Partial<GetIndicatorsQuery> => ({
    rightsId: ids.rightId,
    indicatorsType: ids.type,
    dimension: ids.dimensionID,
    subdimension: ids.subdimensionID,
    indicatorIds: ids.indicatorID,
    ods: ids.odsID,
    priorityGroups: ids.priorityGroups,
});